import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount } from 'vue';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { ModuleName } from '@/types/module-type';
import { ThemeList } from '@/types';
import ThemeClass from '@/components/common/theme/theme-class.vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useConfigStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-assistant',
  props: {
    moduleName: null
  },
  setup(__props: any) {

const props = __props as { moduleName: ModuleName }



// store
const { getConfig } = useConfigStore();

// banner 列表
const bannerList = ref<BannerConfig[]>();
const themeLists = ref<ThemeList[]>([]);

onBeforeMount(async () => {
  // @ts-ignore
  const { bannerList: bannerListVal, travelTools } = await getConfig(props.moduleName);
  bannerList.value = bannerListVal;
  themeLists.value = travelTools;
});

// 处理自定义事件
function onClickCustomEvent(key: string) {}

return { __sfc: true,props, getConfig, bannerList, themeLists, onClickCustomEvent, WphkBanner, ThemeClass, ThemeCard }
}

})